import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatToolbarModule} from '@angular/material/toolbar';

import {FuseSharedModule} from '@fuse/shared.module';
import {AgentCCPWidgetComponent} from 'app/layout/components/routemagic-assistant/agent-ccp-widget/agent-ccp-widget.component';

@NgModule({
    declarations: [AgentCCPWidgetComponent],
    imports: [RouterModule, MatButtonModule, MatIconModule, MatToolbarModule, FuseSharedModule],
    exports: [AgentCCPWidgetComponent]
})
export class AgentCCPWidgetModule {}
